enum CoreUserSortField {
  NAME = 'name',
  VERIFIED_AT = 'verified_at',
  LATEST_ACTIVITY_AT = 'latest_activity_at',
}

export default CoreUserSortField;
